'use strict';
import { __read } from "tslib";
import { of, from, combineLatest } from 'rxjs';
import { map, mergeMap } from 'rxjs/operators';
import _ from 'underscore';
var _User = /** @class */ (function () {
    function _User() {
        this._id = '';
        this.name = '';
        this.email = '';
        this.role = '';
        this.$promise = undefined;
    }
    return _User;
}());
export function AuthService($location, $rootScope, $http, $cookies, $q, Util, User, $window, CommonDataService, AuthEvents, googleAnalytic) {
    'ngInject';
    var userRetrievedEvent = 'auth-user-retrieved';
    var safeCb = Util.safeCb;
    var currentUser = null;
    var userRoles = ['guest', 'user', 'admin'];
    var googleAnalyticsService = googleAnalytic;
    var localStorageUserKey = 'eeLoginUserId';
    /**
     * Check if userRole is >= role
     * @param {String} userRole - role of current user
     * @param {String} role - role to check against
     */
    var hasRole = function (userRole, role) {
        return userRoles.indexOf(userRole) >= userRoles.indexOf(role);
    };
    var Auth = {
        logoutOfServer: function () {
            return $http.get('auth/ares/logoutUrl')
                .then(function (response) { return $http.get(response.data, { withCredentials: true })
                .then(function (response) { if (!response)
                console.error("failed to log out of the auth server"); }); });
        },
        nonceLogin: function (nonce) {
            var config$ = from(Auth.getConfigUrl());
            return config$.pipe(mergeMap(function (configData) {
                var encodedNonce = encodeURIComponent(nonce);
                var url = configData.akrisAuthAPI + "/nonceLogin/nonce-login?nonce=" + encodedNonce;
                window.location.href = url;
            }));
        },
        logoutAndReturn: function (returnUrl) {
            var _this = this;
            return this.logoutOfServer().then(function () {
                $cookies.remove('token');
                return $http.get('auth/ares/logout')
                    .then(function (response) {
                    if (response.status === 200) {
                        currentUser = null;
                        _this.setCurrentUser(currentUser);
                        CommonDataService.setUserData(currentUser);
                        $window.location.href = '/';
                    }
                    else {
                        console.error('logout api returned other than 200 response.....', response);
                    }
                    return response;
                })
                    .catch(function (response) {
                    console.error('logout error response.....', response);
                    return response;
                });
            });
        },
        logout: function () {
            var returnUrl = $location.protocol() + '://' + $location.host();
            this.logoutAndReturn(returnUrl);
        },
        logoutUnauthorizedUser: function () {
            $rootScope.loading = true;
            return this.logoutOfServer().then(function () {
                return $http.get('auth/ares/logout')
                    .finally(function () {
                    currentUser = null;
                    CommonDataService.setUserData(currentUser);
                    $rootScope.shouldRedirectToLogin = false;
                    return $window.open('/auth/ares', '_self');
                });
            });
        },
        setCurrentUser: function (user) {
            // NOT: Every page reload triggers this, so we need to verify that this was the original login using localStorage
            var currentlyLoggedInUser = $window.localStorage.getItem(localStorageUserKey);
            // When the current user isn't set, and is requesting to be set
            // When the current user email doesn't match the new user email
            if (!currentlyLoggedInUser
                && ((!this.currentUser && user)
                    || (this.currentUser && user && this.currentUser.email !== user.email))) {
                // Analytics - GTM Integration
                var eventData = AuthEvents.customerSignInGTMTrackingEvents['customerSignin'];
                googleAnalyticsService.sendGTMEvent(eventData, {
                    practitionerId: user.customerId,
                    eventTimestamp: Date.now()
                });
                // Set the currently logged-in user
                $window.localStorage.setItem(localStorageUserKey, user.customerId);
            }
            if (user === null) {
                // When user is null, the user has logged out (in all cases)
                $window.localStorage.removeItem(localStorageUserKey);
            }
            this.currentUser = user;
            this.notifyUserRetrieved();
        },
        getCurrentUser: function (callback, cache) {
            var _this = this;
            var deferred = $q.defer();
            Auth.checkForLogin()
                .then(function (data) {
                if (data) {
                    User.get(cache)
                        .then(function (response) {
                        if (response.status === 200) {
                            var user = response.data.response;
                            if (response.data.errors) {
                                user.errors = response.data.errors;
                            }
                            if (response.data.warnings) {
                                user.warnings = response.data.warnings;
                            }
                            console.debug('Current user is:' + user.email);
                            safeCb(callback)(user);
                            _this.setCurrentUser(user);
                            return deferred.resolve(user);
                        }
                        else if (response.status === 401) {
                            console.error('Unauthorized..could not find user');
                            safeCb(callback)(null);
                            return deferred.reject(null);
                        }
                    })
                        .catch(function (reason) {
                        console.error('Could not get user!');
                        safeCb(callback)();
                        _this.setCurrentUser(null);
                        return deferred.reject(reason);
                    });
                }
            })
                .catch(function (reason) {
                safeCb(callback)(reason);
                _this.setCurrentUser(null);
                deferred.reject(reason);
            });
            return deferred.promise;
        },
        refreshToken: function () {
            return $http.get('auth/ares/refresh')
                .then(function success(response) {
                console.log(response);
                if (response.status == 200) {
                    console.debug('RefreshToken success response.....', response);
                }
                else {
                    console.error('RefreshToken api returned other than 200 response.....', response);
                }
                return response;
            }, function error(response) {
                console.error('RefreshToken error response.....', response);
                return response;
            });
        },
        isLoggedIn: function (callback) {
            var _this = this;
            if (this.currentUser) {
                safeCb(callback)(this.currentUser);
                return;
            }
            return Auth.getCurrentUser(undefined, true)
                .then(function (user) {
                if (user) {
                    _this.currentUser = user;
                    safeCb(callback)(_this.currentUser);
                    return _this.currentUser;
                }
                else {
                    console.error('No current user found!');
                    safeCb(callback)(null);
                    return null;
                }
            }, function () {
                console.error('No current user!');
                safeCb(callback)({});
                return {};
            });
        },
        checkForLogin: function () {
            return $http.get('/api/account/isLoggedIn', { cache: true })
                .then(function (response) {
                // EK-2358 - this flag helps determine when 401 errors should redirect users back to the login page.
                if (!$rootScope.shouldRedirectToLogin) {
                    $rootScope.shouldRedirectToLogin = !!response.data;
                }
                return response.data;
            })
                .catch(function (reason) {
                console.error(reason);
                return reason;
            });
        },
        clearAccountCache: function () {
            Util.removeCacheForEndPoint('api/account');
        },
        clearLoginCache: function () {
            Util.removeCacheForEndPoint('/api/account/isLoggedIn');
        },
        hasRole: function (role, callback) {
            Auth.checkForLogin()
                .then(function (data) {
                if (data) {
                    return Auth.getCurrentUser(undefined, true)
                        .then(function (user) {
                        var has = hasRole(_.get(user, 'role'), role);
                        safeCb(callback)(has);
                        return has;
                    });
                }
            });
        },
        isAdmin: function () {
            return Auth.hasRole.apply(Auth, [].concat.apply(['admin'], arguments));
        },
        getLoggedInUser: function () {
            return this.currentUser;
        },
        getToken: function () {
            var bearerToken = '';
            var deferred = $q.defer();
            return $http.get('/api/account/token').then(function (response) {
                if (response && response.data && response.data['bearer']) {
                    bearerToken = response.data['bearer'];
                    return bearerToken;
                }
                else {
                    bearerToken = '';
                    deferred.reject(response);
                }
            });
        },
        getUserEmail: function () {
            return Auth.getCurrentUser(undefined, true)
                .then(function (user) {
                return user.email;
            });
        },
        getConfigUrl: function () {
            return $http.get('/api/account/configUrl').then(function (response) {
                if (response && response.data) {
                    return response.data;
                }
                else {
                    $q.defer().reject(response);
                }
            }, function (err) {
                $q.defer().reject(err);
            });
        },
        getGenesysChatConfig: function () {
            return $http.get('/api/account/GenesysChatConfig').then(function (response) {
                if (response && response.data) {
                    return response.data;
                }
                else {
                    $q.defer().reject(response);
                }
            }, function (err) {
                $q.defer().reject(err);
            });
        },
        getSignUpRedirectConfig: function () {
            return $http.get('/api/account/signUpRedirect').then(function (response) {
                if (response && response.data) {
                    return response.data;
                }
                else {
                    $q.defer().reject(response);
                }
            }, function (err) {
                $q.defer().reject(err);
            });
        },
        subscribe: function (scope, callback, cache) {
            var handler = $rootScope.$on(userRetrievedEvent, callback);
            scope.$on('$destroy', handler);
            this.getCurrentUser(undefined, cache);
        },
        notifyUserRetrieved: function () {
            $rootScope.$emit(userRetrievedEvent, this.currentUser);
        },
        calculateStorefrontId: function () {
            if (this.currentUser.salespersonId === "01EEI")
                return 4; // Associate
            var accountType = this.currentUser.accountType.toLowerCase();
            if (accountType === 'patient')
                return 2;
            if (accountType === 'practitioner')
                return 3;
            if (accountType === '24')
                return 8;
            return null;
        },
        checkPlatormForEmail: function (desiredEmail) {
            var config$ = from(Auth.getConfigUrl());
            return config$.pipe(mergeMap(function (configData) {
                var url = configData.akrisAuthAPI + "/users/checkPlatformForEmail/" + desiredEmail;
                return from($http({
                    url: url,
                    type: 'GET',
                })).pipe(map(function (res) {
                    return res.data.body.emailInUse;
                }));
            }));
        },
        checkIfSsoMergeIsPossible: function (checkMergedAccount) {
            if (checkMergedAccount === void 0) { checkMergedAccount = false; }
            var config$ = from(Auth.getConfigUrl());
            var token$ = from(Auth.getToken());
            return combineLatest([config$, token$]).pipe(mergeMap(function (_a) {
                var _b = __read(_a, 2), config = _b[0], token = _b[1];
                if (!token || !config) {
                    return of(false);
                }
                var tokenData;
                try {
                    tokenData = JSON.parse(atob(token.split('.')[1]));
                }
                catch (errIGuess) {
                    return of(false);
                }
                if (!tokenData || !tokenData.sub) {
                    return of(false);
                }
                var url = config.akrisAuthAPI + "/users/" + tokenData.sub + "/merge-eligibility";
                return from($http({
                    url: url,
                    type: 'GET',
                    headers: {
                        Authorization: "Bearer " + token,
                    }
                }));
            }), map(function (checkResult) {
                if (!checkResult || !checkResult.data || !checkResult.data.body) {
                    return false;
                }
                if (checkMergedAccount)
                    return checkResult.data.body.isMergedAccount || false;
                return checkResult.data.body.eligibleForMerge || false;
            }));
        },
        getAkrisUserProfile: function () {
            var config$ = from(Auth.getConfigUrl());
            var token$ = from(Auth.getToken());
            return combineLatest([config$, token$]).pipe(mergeMap(function (_a) {
                var _b = __read(_a, 2), config = _b[0], token = _b[1];
                if (!token || !config) {
                    return of(false);
                }
                var url = config.akrisAuthAPI + "/connect/userinfo";
                return from($http({
                    url: url,
                    type: 'GET',
                    headers: {
                        Authorization: "Bearer " + token,
                    }
                }));
            }), map(function (checkResult) {
                return checkResult.data;
            }));
        },
        updateAkrisUser: function (userData) {
            var config$ = from(Auth.getConfigUrl());
            var token$ = from(Auth.getToken());
            return combineLatest([config$, token$]).pipe(mergeMap(function (_a) {
                var _b = __read(_a, 2), config = _b[0], token = _b[1];
                if (!token || !config) {
                    return of(false);
                }
                var tokenData;
                try {
                    tokenData = JSON.parse(atob(token.split('.')[1]));
                }
                catch (errIGuess) {
                    return of(false);
                }
                if (!tokenData || !tokenData.sub) {
                    return of(false);
                }
                var sub = tokenData.sub;
                if (tokenData.sub.indexOf(":") > -1) {
                    sub = tokenData.sub.split(":")[0];
                }
                var url = config.akrisAuthAPI + "/users/" + sub;
                return from($http({
                    url: url,
                    method: 'PUT',
                    headers: {
                        Authorization: "Bearer " + token,
                    },
                    data: userData.toRequestObject()
                }));
            }), map(function (checkResult) {
                return checkResult;
            }));
        },
    };
    /**
     * Handle 401 errors broadcast by the interceptor provided to $httpProvider in app.js
     */
    $rootScope.$on('unauthorized', function () {
        return Auth.logoutUnauthorizedUser();
    });
    return Auth;
}
//# sourceMappingURL=auth.service.js.map